import React, { useEffect, useState, lazy } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CTAButton } from '../components/CTAButton';
import { CheckCircleIcon, StarIcon, ChevronRightIcon } from 'lucide-react';
import { MetaPixel, trackAddToCart } from '../components/MetaPixel';
export const Advertorial = () => {
  const location = useLocation();
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const getProductLink = () => {
    return `/pdp${location.search}#top`;
  };
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-47">
      <MetaPixel data-id="element-48" />
      <Header data-id="element-49" />
      <main className="flex-grow" data-id="element-50">
        <div className="container mx-auto px-4 py-6" data-id="element-51">
          <div className="mb-6 text-center" data-id="element-52">
            <span className="bg-teal-100 text-teal-800 text-xs font-medium px-2.5 py-0.5 rounded" data-id="element-53">
              Health News
            </span>
            <h1 className="text-2xl md:text-3xl font-bold mt-3 mb-2" data-id="element-54">
              Finally Free Your Feet: The Simple Patch That's Ending Years of
              Hidden Shame
            </h1>
            <p className="text-gray-500 text-sm" data-id="element-55">
              Published: June 15, 2023 | By Dr. Robert Wilson
            </p>
          </div>
          <div className="prose max-w-none" data-id="element-56">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oaXFLpuMmpogXaJSBYmxmy/Google_AI_Studio_2025-08-28T15_17_28.508Z.png" alt="Woman walking confidently in sandals on a sunny day" className="w-full object-cover rounded-lg mb-6" loading="lazy" width="800" height="500" data-id="element-57" />
            <p className="font-medium text-lg mb-4" data-id="element-58">
              Are you hiding your feet because of embarrassing nail fungus?
              You're not alone. Millions suffer in silence, but a breakthrough
              solution is changing lives.
            </p>
            <p className="mb-4" data-id="element-59">
              For decades, people have struggled with stubborn nail fungus that
              seems impossible to eliminate. Traditional treatments often prove
              ineffective, leaving sufferers with discolored, brittle nails that
              cause both physical discomfort and emotional distress.
            </p>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pE9wXRAFzBmVRps5TzPJSn/Google_AI_Studio_2025-08-28T15_28_45.278Z.png" alt="Person carefully drying their feet with a white towel" className="w-full object-cover rounded-lg my-6" loading="lazy" width="800" height="500" data-id="element-60" />
            <div className="bg-[#F0FDFA] p-5 rounded-lg my-6 border-l-4 border-teal-500 italic" data-id="element-61">
              <p className="text-lg" data-id="element-62">
                "I tried everything - expensive creams, home remedies, even oral
                medications with scary side effects. Nothing worked until I
                discovered these patches. For the first time in 15 years, I'm
                not ashamed of my feet."
              </p>
              <p className="text-right font-medium" data-id="element-63">
                — Michael T., Verified Customer
              </p>
            </div>
            <h2 className="text-xl font-bold mt-8 mb-4" data-id="element-64">
              The Hidden Epidemic Affecting 1 in 10 Americans
            </h2>
            <p className="mb-4" data-id="element-65">
              Nail fungus (onychomycosis) affects approximately 10% of the adult
              population, with numbers rising to nearly 50% in those over 70
              years old. Despite its prevalence, effective treatment options
              have remained limited—until now.
            </p>
            <p className="mb-4" data-id="element-66">
              "The problem with traditional treatments is that they don't
              penetrate the nail bed effectively," explains Dr. James Chen, a
              leading dermatologist. "Most topical solutions simply can't reach
              the fungus where it lives, and oral medications carry significant
              risks of liver damage and other side effects."
            </p>
            <div className="bg-gray-100 p-4 rounded-lg my-6" data-id="element-67">
              <h3 className="font-bold mb-2" data-id="element-68">
                Success Story: Sarah's Transformation
              </h3>
              <p className="italic mb-2" data-id="element-69">
                "After my nail fungus spread to six toes, I was desperate. I
                stopped going to yoga class because I was so embarrassed. These
                fungus patches changed everything. After just three weeks, I
                could see clear, healthy nail growing in. Now my feet are
                completely transformed!"
              </p>
              <div className="flex items-center" data-id="element-70">
                <div className="flex" data-id="element-71">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-yellow-400 fill-current" data-id="element-72" />)}
                </div>
                <span className="ml-2 text-sm font-medium" data-id="element-73">
                  Sarah K. - Verified Purchase
                </span>
              </div>
            </div>
            <h2 className="text-xl font-bold mt-8 mb-4" data-id="element-74">
              The Science Behind FungusFreePatch™: How It Works
            </h2>
            <p className="mb-4" data-id="element-75">
              After years of research, scientists have developed
              FungusFreePatch™, a revolutionary treatment that delivers
              powerful antifungal compounds directly to the infection site
              through a proprietary transdermal delivery system.
            </p>
            <div className="my-6" data-id="element-76">
              <h3 className="font-bold mb-3" data-id="element-77">The 3-Step Process:</h3>
              <ol className="list-decimal pl-5 space-y-2" data-id="element-78">
                <li className="font-medium" data-id="element-79">
                  <span className="font-bold" data-id="element-80">Penetration:</span> The patch's
                  micro-needle technology creates microscopic channels in the
                  nail, allowing the active ingredients to bypass the hard nail
                  surface.
                </li>
                <li className="font-medium" data-id="element-81">
                  <span className="font-bold" data-id="element-82">Elimination:</span> A powerful
                  blend of tea tree oil, oregano extract, and
                  pharmaceutical-grade antifungals attacks the fungus directly
                  at its source.
                </li>
                <li className="font-medium" data-id="element-83">
                  <span className="font-bold" data-id="element-84">Restoration:</span> Healing
                  compounds nourish the nail bed, promoting the growth of
                  healthy new nail tissue.
                </li>
              </ol>
            </div>
            <div className="bg-[#F0FDFA] p-5 rounded-lg my-6 border-l-4 border-teal-500 italic" data-id="element-85">
              <p className="text-lg" data-id="element-86">
                "What makes this approach revolutionary is its ability to
                deliver the active ingredients directly to where the fungus
                lives. Traditional treatments simply can't match this level of
                targeted delivery."
              </p>
              <p className="text-right font-medium" data-id="element-87">
                — Dr. Elizabeth Morgan, Podiatrist
              </p>
            </div>
            <div className="my-8" data-id="element-88">
              <h3 className="font-bold text-lg mb-4" data-id="element-89">
                Why People Are Switching to FungusFreePatch™
              </h3>
              <div className="space-y-4" data-id="element-90">
                <div className="flex" data-id="element-91">
                  <div className="bg-[#0F766E] text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0 mr-3" data-id="element-92">
                    1
                  </div>
                  <div data-id="element-93">
                    <h4 className="font-bold" data-id="element-94">No More Embarrassment</h4>
                    <p className="text-gray-700" data-id="element-95">
                      Users report being able to wear sandals and go barefoot
                      with confidence for the first time in years.
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-96">
                  <div className="bg-[#0F766E] text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0 mr-3" data-id="element-97">
                    2
                  </div>
                  <div data-id="element-98">
                    <h4 className="font-bold" data-id="element-99">Fast, Visible Results</h4>
                    <p className="text-gray-700" data-id="element-100">
                      While complete treatment takes time, many users report
                      seeing improvement in just 10-14 days.
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-101">
                  <div className="bg-[#0F766E] text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0 mr-3" data-id="element-102">
                    3
                  </div>
                  <div data-id="element-103">
                    <h4 className="font-bold" data-id="element-104">No Side Effects</h4>
                    <p className="text-gray-700" data-id="element-105">
                      Unlike oral medications that can damage your liver,
                      FungusFreePatch™ works locally with no systemic side
                      effects.
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-106">
                  <div className="bg-[#0F766E] text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0 mr-3" data-id="element-107">
                    4
                  </div>
                  <div data-id="element-108">
                    <h4 className="font-bold" data-id="element-109">Simple Application</h4>
                    <p className="text-gray-700" data-id="element-110">
                      Just apply the patch before bed and remove in the morning.
                      No messy creams or complicated procedures.
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-111">
                  <div className="bg-[#0F766E] text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0 mr-3" data-id="element-112">
                    5
                  </div>
                  <div data-id="element-113">
                    <h4 className="font-bold" data-id="element-114">Cost-Effective</h4>
                    <p className="text-gray-700" data-id="element-115">
                      Compared to prescription medications and doctor visits,
                      FungusFreePatch™ offers a more affordable solution with
                      better results.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg my-6" data-id="element-116">
              <h3 className="font-bold mb-2" data-id="element-117">Expert Opinion</h3>
              <p className="italic mb-2" data-id="element-118">
                "In my 25 years of practice, I've never seen a treatment as
                effective as these fungus patches. The before-and-after photos
                from my patients are truly remarkable. I'm now recommending them
                as a first-line treatment for nail fungus."
              </p>
              <p className="text-sm font-medium" data-id="element-119">
                - Dr. Richard Johnson, Podiatric Medicine Specialist
              </p>
            </div>
            <h2 className="text-xl font-bold mt-8 mb-4" data-id="element-120">
              Real People, Real Results
            </h2>
            <div className="grid md:grid-cols-2 gap-6 my-6" data-id="element-121">
              <div className="bg-gray-100 p-4 rounded-lg" data-id="element-122">
                <div className="flex items-center mb-3" data-id="element-123">
                  <div className="flex" data-id="element-124">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-yellow-400 fill-current" data-id="element-125" />)}
                  </div>
                  <span className="ml-2 text-sm font-medium" data-id="element-126">
                    Verified Purchase
                  </span>
                </div>
                <p className="italic mb-2" data-id="element-127">
                  "I had nail fungus for over 8 years and tried everything.
                  Within a month of using these patches, I could see healthy
                  nail growing in. It's been 3 months now and my nails look
                  completely normal again!"
                </p>
                <p className="text-sm font-medium" data-id="element-128">- David R.</p>
              </div>
              <div className="bg-gray-100 p-4 rounded-lg" data-id="element-129">
                <div className="flex items-center mb-3" data-id="element-130">
                  <div className="flex" data-id="element-131">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-yellow-400 fill-current" data-id="element-132" />)}
                  </div>
                  <span className="ml-2 text-sm font-medium" data-id="element-133">
                    Verified Purchase
                  </span>
                </div>
                <p className="italic mb-2" data-id="element-134">
                  "As a diabetic, I was worried about my nail fungus leading to
                  more serious complications. My doctor recommended these
                  patches, and they've made an incredible difference. No more
                  thick, yellow nails!"
                </p>
                <p className="text-sm font-medium" data-id="element-135">- Patricia M.</p>
              </div>
            </div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iuPpbmWDESaAeVMjaiQChw/Google_AI_Studio_2025-08-28T15_33_42.526Z.png" alt="Group of women enjoying time together outdoors with confidence" className="w-full object-cover rounded-lg my-6" loading="lazy" width="800" height="500" data-id="element-136" />
          </div>
          <div className="mt-8 mb-12 text-center" data-id="element-137">
            <h2 className="text-2xl font-bold mb-4" data-id="element-138">
              Ready to Free Your Feet from Fungus?
            </h2>
            <p className="mb-6" data-id="element-139">
              Join thousands of satisfied customers who have transformed their
              nails with FungusFreePatch™.
            </p>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5PcrtcvvJwRQ9hCzBacXFK/Google_AI_Studio_2025-08-28T15_15_10.481Z.png" alt="Woman walking confidently in sandals on a sunny day" className="w-full object-cover rounded-lg mb-6" loading="lazy" width="800" height="500" data-id="element-140" />
            <CTAButton text="See FungusFreePatch™ Details" to={getProductLink()} fullWidth={true} data-id="element-141" />
          </div>
        </div>
      </main>
      <Footer data-id="element-142" />
      {/* Sticky CTA */}
      <div className={`fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 p-3 transition-transform duration-300 ${isSticky ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-143">
        <div className="container mx-auto" data-id="element-144">
          <Link to={getProductLink()} className="flex items-center justify-center bg-[#0F766E] text-white font-medium py-3 px-6 rounded-lg hover:bg-teal-800 transition-colors w-full" onClick={trackAddToCart} data-id="element-145">
            Continue → Product Details
            <ChevronRightIcon size={18} className="ml-1" data-id="element-146" />
          </Link>
        </div>
      </div>
    </div>;
};